import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  inject
} from '@angular/core';

import { Subject, filter, map, takeUntil } from 'rxjs';

import { UserAccountData } from '@hdms/shared/page-frame/types';
import { ModalComponent } from '@hdms/shared/ui-core';
import { HashTriggerService } from '@hdms/shared/util-core';

import { CONTACT_US_HASHES, ContactTabType } from '../../../config/header-config.const';
import { MenuStateService } from '../../../services';

@Component({
  selector: 'shrd-pf-ft-contact-modal',
  templateUrl: './contact-modal.component.html',
  styleUrls: ['./contact-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ContactModalComponent implements OnInit, OnDestroy {
  @ViewChild('contactModal', { static: true }) readonly contactModal: ModalComponent;

  @Input() userData: UserAccountData;

  activeTab: ContactTabType;

  private readonly hashTrigger = inject(HashTriggerService);
  private readonly menuState = inject(MenuStateService);
  private readonly unsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.hashTrigger.registerHash(...Object.keys(CONTACT_US_HASHES));

    this.hashTrigger.hashChange$
      .pipe(
        map(hash => this.checkHash(hash)),
        filter(Boolean),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(_ => this.contactModal.open());

    this.menuState.close$.pipe(takeUntil(this.unsubscribe$)).subscribe(_ => this.contactModal.close());
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private checkHash(hash: string): boolean {
    this.activeTab = CONTACT_US_HASHES[hash];
    return !!this.activeTab;
  }
}
